<template>
    <el-carousel height="100%" id="container" class="slideshow"
                 pause-on-hover="false" interval="5000" arrow="never" indicator-position="none">
        <el-carousel-item v-for="item in 4" :key="item">
            <div v-if="item%2!=0" class="carousel-item" :style="{backgroundImage:'url('+imgBg1+')'}"></div>
            <div v-else class="carousel-item" :style="{backgroundImage:'url('+imgBg2+')'}"></div>
        </el-carousel-item>
    </el-carousel>
    <div id="container" class="slideshow">
        <div id="top">
            <img src="@/assets/logo_mete_b.svg">
        </div>

        <div id="bottom">
            <div id="mainWrap">

                <div id="registerWrap">
                    <div class='logo'><img src="@/assets/logo_mete_s.svg"></div>
                    <div id='header'><p class="white">歡迎登入</p><p class="blue">METE</p></div>
                    <el-form :model="form" :rules="rules" ref="formRef" :inline-message="true">
                        <input type="text" id="company" v-model="form.VENDOR_ID" v-on:keyup.enter="onLogin()" class="registInfo" placeholder="公司代號" autocomplete="off" />
                        <input type="text" id="user" v-model="form.USER_ID" v-on:keyup.enter="onLogin()" class="registInfo" placeholder="使用者帳號" autocomplete="off" />
                        <div style="position: relative; width: auto;">
                            <input type="password" id="password" v-model="form.USER_PWD" v-on:keyup.enter="onLogin()" class="registInfo" placeholder="密碼" autocomplete="off" />
                            <el-icon v-if="eye" @click="showPass" style="position: absolute; height:48px; color: white; font-size: 20px; right: 10px"><Hide /></el-icon>
                            <el-icon v-else @click="showPass" style="position: absolute; height:48px; color: white; font-size: 20px; right: 10px"><View /></el-icon>
                        </div>
                        <div class="captcha_wrap">
                            <input type="text" id="captcha" v-model="form.CAPTCHA" v-on:keyup.enter="onLogin()" class="registInfo" placeholder="驗證碼" autocomplete="off" />
                            <div class="number">
                                <PicCode v-model:Code="Code" />
                            </div>
                        </div>
                    </el-form>
                    <div><a href="#" id="forgot">忘記帳號或密碼？</a></div>
                    <button class="login" @click="onLogin">登入</button>
                    <div id="more"><p>不是會員? &nbsp;</p><a href="#" id="more">聯繫瞭解更多</a></div>
                </div>


                <div id="sloganWrap">
                    <h1>Deliver Smartly with Mete.</h1>
                    <p>
                        以堅實的車隊與系統服務，為企業與電商用戶解決各式貨運與物流需求，提供包含外送物流整合、全台快電商配送、冷鏈專車、低溫宅配、低溫倉儲等服務
                    </p>
                </div>

            </div>

        </div>
    </div>
</template>

<script setup>
    import { ref, reactive, computed, onMounted, nextTick, watch } from 'vue';
    import { ElMessage, ElMessageBox } from 'element-plus';
    import PicCode from "@/components/PicCode.vue";
    import $api from '@/utils/axios';
    import store from '../utils/store';
    import { useRouter } from 'vue-router'
    const router = useRouter();
    const Code = ref(1);
    import img1 from '@/assets/img_bg_1.jpg';
    import img2 from '@/assets/img_bg_2.jpg';
    const imgBg1 = computed(() => img1);
    const imgBg2 = computed(() => img2);

    const form = reactive({
        VENDOR_ID: '',
        USER_ID: '',
        USER_PWD: '',
        CAPTCHA: ''
    });

    const formRef = ref(null);
    const rules = ref({});

    const eye = ref(true); // hide password
    const showPass = () => {
        if (eye.value) {
            eye.value = false; // show password
            document.getElementById('password').type = 'text';
        } else {
            eye.value = true;
            document.getElementById('password').type = 'password';
        }
    }

    const onLogin = () => {
        //console.log(form);
        //console.log(Code.value);
        if (form.CAPTCHA.toLowerCase() == Code.value.toString()) {
            store.dispatch("loading_open");
            $api.POST("/api/User/Login", form, {
            }).then((response) => {
                if (response.TOKEN == null) { //找不到使用者
                    store.dispatch("loading_close");
                    ElMessageBox.alert('登入失敗', '提示', {
                        confirmButtonText: 'OK'
                    });
                } else if (response.TOKEN == "405") { //密碼已過期
                    ElMessageBox.alert('登入失敗，密碼已過期', '提示', {
                        confirmButtonText: 'OK'
                    });
                } else if (response.DISABLE_FG == "Y") {
                    ElMessageBox.alert('登入失敗，公司/門店代號已停用！', '提示', {
                        confirmButtonText: 'OK'
                    });
                }
                else {
                    localStorage.setItem("OtlUserSeq", response.OTL_USER_SEQ);
                    localStorage.setItem("CustCode", response.CUST_CODE);
                    localStorage.setItem("VendorId", response.VENDOR_ID);
                    localStorage.setItem("BrandName", response.BRAND_NAME);
                    localStorage.setItem("VendorType", response.ROLE_TYPE); //公司角色類別
                    localStorage.setItem("UserCode", response.USER_CODE);
                    localStorage.setItem("UserName", response.USER_NAME);
                    localStorage.setItem("BalAmt", response.BAL_AMT); //餘額
                    //localStorage.setItem("RoleId", response.ROLE_ID); // 使用者角色
                    localStorage.setItem("Token", response.TOKEN);

                    router.push('/Home');
                } 
                
                store.dispatch("loading_close");
            }).catch((error) => {
                store.dispatch("loading_close");
                ElMessageBox.alert('登入失敗', '提示', {
                    confirmButtonText: 'OK'
                });
                console.log("Login Error:", error);
            });
        } else {
            ElMessageBox.alert('驗證碼錯誤', '提示', {
                confirmButtonText: 'OK'
            });
        }
    }
</script>
<style scoped lang="scss">
    @import '../styles/Site.scss';

    .carousel-item {
        height: 100%;
        background-size: cover;
    }

    #sloganWrap h1 {
        font-family: Arial;
        font-weight: bold;
    }
</style>